// Rule actions are config-driven so new actions slot in by adding an entry.
// Each maps a backend flag column + the legacy `Action` id.
export const RULE_ACTIONS = [
  {
    key: "FlagActionArchive",
    actionId: 1,
    label: "Archive email",
    description: "Automatically move matching emails to the archive.",
    icon: "ri-archive-line",
    colour: "warning",
  },
  // Future actions, e.g.:
  // { key: "FlagActionDelete", actionId: 2, label: "Delete email", ... },
  // { key: "FlagActionMarkRead", actionId: 3, label: "Mark as read", ... },
];

// FlagMatchAll: 1 = every condition must match (AND), 0 = any matches (OR).
export const MATCH_ALL = 1;
export const MATCH_ANY = 0;

export const emptyConditionRow = () => ({
  EmailInboundRuleItemField_Id: "",
  SystemFunctionOperand_Id: "",
  Value: "",
});
